module.exports = __webpack_public_path__ + "img/existing-card.851cb157.png";